import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RoutesRecognized } from '@angular/router';
import { AuthService } from './authmanagement/services/Auth.service';


@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
})
export class AppComponent implements OnInit {
  constructor(private authService: AuthService, private router: Router, private activatedRoute: ActivatedRoute) {
    this.IsAuthenticated = false;
  }
  public IsAuthenticated: boolean;
  title = "app";
  rutaActual: string;
  isNavVisible: boolean = false;

  ngOnInit() {
    this.CheckRoute();
  }
  CheckAuthentication() {
    if (!(this.rutaActual === '/' || this.rutaActual === '/home' || this.rutaActual === '/callback' || this.rutaActual === '/error' || this.rutaActual.includes('/recoveryPassword'))) {
      this.authService
        .checkAuthenticated()
        .subscribe((arg) => (this.IsAuthenticated = arg));
      console.log("Authenticated:" + this.IsAuthenticated);
    }
  }

  CheckRoute(){
    this.router.events.subscribe((event) => {
      if (event instanceof RoutesRecognized) {
        console.log(event.url);
        this.rutaActual = event.url;
        this.CheckAuthentication();
        if (this.rutaActual === '/' || this.rutaActual === '/login' || this.rutaActual === '/home' || this.rutaActual === '/callback' || this.rutaActual === '/error' || this.rutaActual == undefined || this.rutaActual.includes('/recoveryPassword')) {
          this.isNavVisible = false;
        } else {
          this.isNavVisible = true;
        }
      }
    });
  }
  
}

  

